import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {BlobLinkPreviewTabProvider} from 'notebook/data-tables/BlobLinkPreviewTabContext';
import StandaloneResultsView from 'results/assays/StandaloneResultsView';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import * as Headers from 'ui-library/Headers';
import APIUtil from 'util/APIUtil';

export function StorableResultsView(props: {storableId: string}): JSX.Element {
  return (
    <div className="react-tab-container react-tab-container--mediocre-contentWrapper">
      <Headers.Header1>{MODEL_NAMES.Results}</Headers.Header1>
      <div className="u-small-spacing-top">
        <BlobLinkPreviewTabProvider fileId={props.storableId}>
          <StandaloneResultsView
            emptyMessage={`No ${MODEL_NAMES.results} are linked to this ${APIUtil.apiIdToType(
              props.storableId
            )}`}
            filters={{storableId: props.storableId}}
            includeResultsAgainstArchivedSchemas={
              BenchlingConfig.RESULTS_SHOW_ARCHIVED_SCHEMAS_ON_RESULTS_TAB
            }
          />
        </BlobLinkPreviewTabProvider>
      </div>
    </div>
  );
}

export default StorableResultsView;
